import useAxios from 'axios-hooks';

/**
 * This Fetches visually similar items of multiple items
 * @param schemaName
 * @param itemId
 * @param storeId
 */

export const useDynamicRecs = ({
  schemaName, anchor, storeId, key, manual = false
}) => {
  const url = (anchor.split(',').length > 1)
    ? `/multianchordynamicrecs/${schemaName}` : `/dynamicrecs/${schemaName}`;

  const [{ data, loading, error }, executeCall] = useAxios({
    url,
    params: { anchor, storeId, key }
  }, {
    manual
  });
  const metadata = !loading && (data?.metadata || {});
  // Below Will be removed once we get new API
  const productSkus = !loading && (data?.products || []).map((product) => `${product.productId}`);

  return {
    metadata,
    loading,
    error,
    data,
    productSkus,
    executeCall
  };
};
